






































































































































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import BaseVue from "../../core/BaseVue";
import UserService from "@/services/user.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import PorposalService from "@/services/porposal.service";
import PorposalUserReportEvaluations from "../../models/porposal/porposalUserReportEvaluations.model";
import { ReportEvaluationState } from "@/enums/ReportEvaluationState";
import fileService from "@/services/file.service";
import PorposalDetail from "@/components/porposal-detail-component/detail.vue";
import ProposalUserReport from "@/models/porposal/porposalUserReport.model";
import GenericEdit from "@/core/Generics/GenericEdit";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import BudgetExpenseService from "@/services/budgetExpense.service";
import ProposalUserReportService from "@/services/proposalUserReport.service";
import ProposalBudgetItemExecution from "@/models/porposal/proposalBudgetItemExecution.model";
import ProposalBudgetSubItemExecution from "@/models/porposal/proposalBudgetSubItemExecution.model";
import { Utils } from "@/core/Utils";
import ProposalBudgetSubItemExecutionDocument from "../../models/porposal/proposalBudgetSubItemExecutionDocument.model";
import ProposalScheduleGanttPhase from "../../models/porposal/proposalScheduleGanttPhase.model";
import GantCharttComponent from "@/components/ganttChart/gantChartt.vue";
import { ProposalState } from "@/enums/ProposalState";
import BudgetSubItemEvaluation from "@/models/porposal/budgetSubItemEvaluation.model";
import BudgetItemEvaluation from "@/models/porposal/budgetItemEvaluation.model";

@Component({
  components: {
    ResearchCenterBasicInformationComponent,
    DatePickerComponent,
    GantCharttComponent
  }
})
export default class PorposalReportEvaluation extends GenericEdit<
  ProposalUserReport
> {
  // services
  proposalUserReportService: ProposalUserReportService = new ProposalUserReportService();
  budgetExpenseService: BudgetExpenseService = new BudgetExpenseService();
  porposalRepository: PorposalService = new PorposalService();

  // state managment
  state: ReportEvaluationState = null;
  pendiente: ReportEvaluationState = ReportEvaluationState.Pendiente;
  aprobado: ReportEvaluationState = ReportEvaluationState.Aprobado;
  noAprobado: ReportEvaluationState = ReportEvaluationState.NoAprobado;

  // ui managers
  loading: boolean = false;
  showModal: boolean = false;
  isApproved: boolean = true;

  // data
  currentProposalUserReportEvaluation: PorposalUserReportEvaluations = null;
  proposalScheduleGanttPhases: Array<ProposalScheduleGanttPhase> = [];
  budgetExpenses: any = [];
  isEvaluated: boolean = false;

  aprobadaFc = ProposalState.AprobadoFC;


  constructor() {
    super();
    this.controller = "PorposalUserReport";
    this.model = new ProposalUserReport();
  }

  async created() {}

  protected async getData() {
    try {
      this.loading = true;
      this.currentProposalUserReportEvaluation = await this.proposalUserReportService.getProposalUserReportByEvaluationId(
        Number(this.$route.params.rid)
      );
      this.isEvaluated = this.currentProposalUserReportEvaluation.state == this.pendiente ? false : true;

      this.model = await this.repository.byId(
        this.currentProposalUserReportEvaluation.porposalUserReportId,
        this.include
      );
      if (this.model.startPeriod)
        this.model.startPeriod = new Date(this.model.startPeriod);
      if (this.model.endPeriod)
        this.model.endPeriod = new Date(this.model.endPeriod);

      // evaluations
      
      if (
        this.currentProposalUserReportEvaluation.budgetItemEvaluations.length ==
        0
      ) {
        
        for (
          let i = 0;
          i < this.model.proposalBudgetItemsExecution.length;
          i++
        ) {
          const proposalBudgetItemsExecution = this.model
            .proposalBudgetItemsExecution[i];
          if (!proposalBudgetItemsExecution.budgetItemEvaluationUI) {
            proposalBudgetItemsExecution.budgetItemEvaluationUI = new BudgetItemEvaluation();
            proposalBudgetItemsExecution.budgetItemEvaluationUI.porposalUserReportEvaluationId = this.currentProposalUserReportEvaluation.id;
            proposalBudgetItemsExecution.budgetItemEvaluationUI.proposalBudgetItemExecutionId =
              proposalBudgetItemsExecution.id;
          }
          for (
            let y = 0;
            y <
            proposalBudgetItemsExecution.proposalBudgetSubItemsExecution.length;
            y++
          ) {
            const subItem =
              proposalBudgetItemsExecution.proposalBudgetSubItemsExecution[y];
            if (!subItem.budgetSubItemEvaluationUI) {
              subItem.budgetSubItemEvaluationUI = new BudgetSubItemEvaluation();
              subItem.budgetSubItemEvaluationUI.proposalBudgetSubItemExecutionId =
                subItem.id;
              subItem.budgetSubItemEvaluationUI.state = this.pendiente;
              subItem.budgetSubItemEvaluationUI.identifierUI = Utils.newGUID();
            }
          }
        }
      } else {
        for (
          let i = 0;
          i < this.model.proposalBudgetItemsExecution.length;
          i++
        ) {
          const proposalBudgetItemsExecution = this.model
            .proposalBudgetItemsExecution[i];
          proposalBudgetItemsExecution.budgetItemEvaluationUI = this.currentProposalUserReportEvaluation.budgetItemEvaluations.find(
            x =>
              x.proposalBudgetItemExecutionId == proposalBudgetItemsExecution.id
          );
          for (
            let y = 0;
            y <
            proposalBudgetItemsExecution.proposalBudgetSubItemsExecution.length;
            y++
          ) {
            const subItem =
              proposalBudgetItemsExecution.proposalBudgetSubItemsExecution[y];
            subItem.budgetSubItemEvaluationUI = proposalBudgetItemsExecution.budgetItemEvaluationUI.budgetSubItemEvaluations.find(
              x => x.proposalBudgetSubItemExecutionId == subItem.id
            );
            subItem.budgetSubItemEvaluationUI.identifierUI = Utils.newGUID();
            subItem.budgetSubItemEvaluationUI.stateUI = subItem.budgetSubItemEvaluationUI.state;
          }
        }
      }

      // gant chart
      let gantChart = await this.proposalUserReportService.getByEvaluacionType(
        this.model.proposalHistoricPercentDoneScheduleGanttId,
        this.model.proposalId
      );
      let lastGanttHistory = gantChart.proposalHistoricPercentDoneScheduleGantt;
      for (let i = 0; i < gantChart.proposalScheduleGanttPhases.length; i++) {
        const phase = lastGanttHistory.proposalHistoricPhasesPercentDone.find(
          x =>
            x.proposalScheduleGanttPhaseId ==
            gantChart.proposalScheduleGanttPhases[i].id
        );
        gantChart.proposalScheduleGanttPhases[i].percentDone =
          phase.percentDone;
        gantChart.proposalScheduleGanttPhases[i].percentDoneUI =
          phase.percentDone;
        for (
          let j = 0;
          j <
          gantChart.proposalScheduleGanttPhases[i]
            .proposalScheduleGanttActivities.length;
          j++
        ) {
          const activity = phase.proposalHistoricActivitiesPercentDone.find(
            x =>
              x.proposalScheduleGanttActivityId ==
              gantChart.proposalScheduleGanttPhases[i]
                .proposalScheduleGanttActivities[j].id
          );
          gantChart.proposalScheduleGanttPhases[
            i
          ].proposalScheduleGanttActivities[j].percentDone =
            activity.percentDone;
          gantChart.proposalScheduleGanttPhases[
            i
          ].proposalScheduleGanttActivities[j].percentDoneUI =
            activity.percentDone;
        }
      }
      this.proposalScheduleGanttPhases = gantChart.proposalScheduleGanttPhases;

      this.getBudgetExpenses();
      this.currentModelChange();
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }

  getBudgetExpenses() {
    this.budgetExpenseService.getBudgetExpenses().then(response => {
      if (response) {
        this.budgetExpenses = response.filter(x =>
          this.model.porposalBudgetItems.some(y => y.budgetExpenseId == x.id)
        );
      }
    });
  }

  currentModelChange() {
    if (!this.model.proposalBudgetItemsExecution.length) {
      for (let i = 0; i < this.model.porposalBudgetItems.length; i++) {
        const porposalBudgetItem = this.model.porposalBudgetItems[i];
        var proposalBudgetItemExecution = new ProposalBudgetItemExecution();
        proposalBudgetItemExecution.porposalBudgetItemId =
          porposalBudgetItem.id;
        proposalBudgetItemExecution.porposalBudgetItem = porposalBudgetItem;

        for (
          let y = 0;
          y < porposalBudgetItem.porposalBudgetSubItems.length;
          y++
        ) {
          const subItem = porposalBudgetItem.porposalBudgetSubItems[y];
          var proposalBudgetSubItemExecution = new ProposalBudgetSubItemExecution();
          proposalBudgetSubItemExecution.porposalBudgetSubItemId = subItem.id;
          proposalBudgetSubItemExecution.porposalBudgetSubItem = subItem;
          proposalBudgetItemExecution.proposalBudgetSubItemsExecution.push(
            proposalBudgetSubItemExecution
          );
        }

        this.model.proposalBudgetItemsExecution.push(
          proposalBudgetItemExecution
        );
      }
    }
  }

  goToTable() {
    this.$router.push('/proposal/pendingReports/evaluations');
  }


  async save(send: boolean) {
    if (this.model.proposalBudgetItemsExecution.length) {
      for (let i = 0; i < this.model.proposalBudgetItemsExecution.length; i++) {
        const proposalBudgetItemsExecution = this.model
          .proposalBudgetItemsExecution[i];
        for (
          let y = 0;
          y <
          proposalBudgetItemsExecution.proposalBudgetSubItemsExecution.length;
          y++
        ) {
          const subItem =
            proposalBudgetItemsExecution.proposalBudgetSubItemsExecution[y];
          if (
            proposalBudgetItemsExecution.budgetItemEvaluationUI.budgetSubItemEvaluations.some(
              x =>
                x.proposalBudgetSubItemExecutionId ==
                subItem.budgetSubItemEvaluationUI
                  .proposalBudgetSubItemExecutionId
            )
          ) {
            let existingBudgetSubItemEvaluationUI = proposalBudgetItemsExecution.budgetItemEvaluationUI.budgetSubItemEvaluations.find(
              x =>
                x.proposalBudgetSubItemExecutionId ==
                subItem.budgetSubItemEvaluationUI
                  .proposalBudgetSubItemExecutionId
            );
            existingBudgetSubItemEvaluationUI.state =
              subItem.budgetSubItemEvaluationUI.state;
            existingBudgetSubItemEvaluationUI.reason =
              subItem.budgetSubItemEvaluationUI.reason;
          } else {
            proposalBudgetItemsExecution.budgetItemEvaluationUI.budgetSubItemEvaluations.push(
              subItem.budgetSubItemEvaluationUI
            );
          }
        }
        if (
          this.currentProposalUserReportEvaluation.budgetItemEvaluations.some(
            x =>
              x.proposalBudgetItemExecutionId ==
              proposalBudgetItemsExecution.budgetItemEvaluationUI
                .proposalBudgetItemExecutionId
          )
        ) {
          let existingBudgetItemEvaluation = this.currentProposalUserReportEvaluation.budgetItemEvaluations.find(
            x =>
              x.proposalBudgetItemExecutionId ==
              proposalBudgetItemsExecution.budgetItemEvaluationUI
                .proposalBudgetItemExecutionId
          );
          existingBudgetItemEvaluation.budgetSubItemEvaluations =
            proposalBudgetItemsExecution.budgetItemEvaluationUI.budgetSubItemEvaluations;
        } else {
          this.currentProposalUserReportEvaluation.budgetItemEvaluations.push(
            proposalBudgetItemsExecution.budgetItemEvaluationUI
          );
        }
      }
    }
    
    if (send) {
      let subItemsNotEvaluated = [];
      this.currentProposalUserReportEvaluation.budgetItemEvaluations.forEach(budgetItemEvaluation => {
        budgetItemEvaluation.budgetSubItemEvaluations.forEach(budgetSubItemEvaluation => {
          if (!budgetSubItemEvaluation.state || budgetSubItemEvaluation.state == this.pendiente || !budgetSubItemEvaluation.reason) {
            let proposalBudgetItemsExecution = this.model.proposalBudgetItemsExecution.find((x:any) => x.proposalBudgetSubItemsExecution.find(y => y.id == budgetSubItemEvaluation.proposalBudgetSubItemExecutionId));
            let subItem = proposalBudgetItemsExecution.proposalBudgetSubItemsExecution.find((x:any) => x.id == budgetSubItemEvaluation.proposalBudgetSubItemExecutionId);
            if (subItem.amountSpent > 0) {
              subItemsNotEvaluated.push(subItem.porposalBudgetSubItem.budgetSubItem);
            } else {
              budgetSubItemEvaluation.state = this.aprobado;
            }
          }
        });
      });
      if (subItemsNotEvaluated.length > 0) {
        subItemsNotEvaluated.forEach(subItem => {
          this.operationNoAllowed(`Debe completar los datos de la sub partida ${subItem}`, 2500);
        });
        return;
      } else {
        this.loading = true;
        await this.proposalUserReportService.updateAndSendProposalUserReportEvaluation(this.currentProposalUserReportEvaluation);
        this.isEvaluated = true;
      }
    } else {
      this.loading = true;
      await this.proposalUserReportService.updateProposalUserReportEvaluation(this.currentProposalUserReportEvaluation);
    }
    
    this.loading = false;
    this.operationSuccess();
  }

  async onChangeFiles(subItem: ProposalBudgetSubItemExecution) {
    if (subItem.files.length && subItem.files.some(x => x.size)) {
      this.loading = true;
      let docs = await fileService.uploadMany(subItem.files as File[]);

      docs.forEach(doc => {
        var newDoc = new ProposalBudgetSubItemExecutionDocument();
        newDoc.name = doc.originalName;
        newDoc.document = doc;
        subItem.proposalBudgetSubItemExecutionDocuments.push(newDoc);
      });
      this.loading = false;
      subItem.files = [];
    }
  }

  calculateTotalSpentByBudgetItem(row: ProposalBudgetItemExecution) {
    return row.proposalBudgetSubItemsExecution.reduce((a, b) => {
      return a + b.amountSpent;
    }, 0);
  }

  calculateTotalAmountSpentByBudgetExpense(
    rows: Array<ProposalBudgetItemExecution>
  ) {
    return rows.reduce((a, b) => {
      var result = b.proposalBudgetSubItemsExecution.reduce((c, d) => {
        return c + d.amountSpent;
      }, 0);

      return a + result;
    }, 0);
  }

  async downloadFile(file: any) {
    
    if (file.document.contentType == "application/octet-stream" || file.document.contentType ==  "application/msword")
      await fileService.downloadOctetFile(
        file.document.id,
        file.document.originalName
      );
    else await fileService.download(file.document.id);
  }

  get totalSpent() {
    return this.model.proposalBudgetItemsExecution.reduce((a, b) => {
      var result = b.proposalBudgetSubItemsExecution.reduce((c, d) => {
        return c + d.amountSpent;
      }, 0);

      return a + result;
    }, 0);
  }
}
